export const EnumTipoDocumentoPaciente = () => {
  return [
    { tipo: 'CURRICULO', descricao: 'Currículo' },
    { tipo: 'DIPLOMA_GRADUACAO', descricao: 'Diploma de Graduação' },
    { tipo: 'DIPLOMA_POS_GRADUACAO', descricao: 'Diploma de Pós Graduação' },
    { tipo: 'DIPLOMA_MESTRADO', descricao: 'Diploma de Mestrado' },
    { tipo: 'DIPLOMA_DOUTORADO', descricao: 'Diploma de Mestrado' },
    { tipo: 'CURSO_EXTRACURRICULAR', descricao: 'Curso Extra Curricular' },
    { tipo: 'CURSO_ESPECIALIZAÇÃO', descricao: 'Curso Especialização' },
    { tipo: 'CARTEIRA_CNH', descricao: 'CNH' },
    { tipo: 'CARTEIRA_CRM', descricao: 'Carteira CRM' },
    { tipo: 'EXAME', descricao: 'Exame' },
    { tipo: 'LAUDO', descricao: 'Laudo' },
    { tipo: 'DOCUMENTO', descricao: 'Documento' },
    { tipo: 'DADOS_MEDICO', descricao: 'Dados Médico de inserção' },
    { tipo: 'OUTROS', descricao: 'Outros' },
  ];
};
